import React from 'react';
import styled from 'styled-components';

import { Icon } from '@ontruck/orc';

const StyledIconContainer = styled.span`
  display: inline-block;
  width: 24px;
  margin-right: 8px;
`;

const ExtrasCell = ({
  handling,
  lifgate,
  sideload,
  topload,
  size = '2.4rem',
  color = 'grey500',
}) => {
  return (
    <>
      <StyledIconContainer>
        {handling && <Icon glyph="manipulation" size={`calc(${size} * 0.75)`} color={color} />}
      </StyledIconContainer>
      <StyledIconContainer>
        {lifgate && <Icon glyph="extras-liftgate" size={size} color={color} />}
      </StyledIconContainer>
      <StyledIconContainer>
        {sideload && <Icon glyph="extras-sideload" size={size} color={color} />}
      </StyledIconContainer>
      <StyledIconContainer>
        {topload && <Icon glyph="extras-retractableroof" size={size} color={color} />}
      </StyledIconContainer>
    </>
  );
};

export default ExtrasCell;
